import React from 'react';
import Icon from 'components/AppIcon';
import { Alert } from 'antd';

const VerificationStep = ({ formData }) => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 bg-accent-100">
          <Icon name="Mail" size={24} className="text-accent" />
        </div>
        <h3 className="text-lg font-semibold text-text-primary mb-2">
          Подтвердите email
        </h3>
        <p className="text-text-secondary">
          Мы отправили письмо со ссылкой для подтверждения на адрес{' '}
          <span className="font-medium text-text-primary">{formData.email}</span>
        </p>
      </div>

      <Alert
        type="info"
        showIcon
        message="Ожидаем подтверждения"
        description="Перейдите по ссылке из письма, чтобы подтвердить email и активировать аккаунт. Пока подтверждение не получено, войти в систему не получится."
      />

      <Alert
        type="warning"
        showIcon
        message="Не приходит письмо?"
        description="Проверьте папку «Спам» — доставка может занять несколько минут. Если письмо так и не пришло, обратитесь в поддержку."
      />

      {/* Help Section */}
      <div className="pt-4 border-t border-secondary-200 text-center">
        <p className="text-sm text-text-secondary mb-2">
          Возникли проблемы с подтверждением?
        </p>
        <a href="/support" className="hover:text-primary transition-colors duration-150">
          Связаться с поддержкой
        </a>
      </div>
    </div>
  );
};

export default VerificationStep;